export const M1_UNIT_7 = {
  id: "u7-everyday-things",
  title: "Unidad 7: Everyday Things",
  topic: "Objetos cotidianos y posesiones",
  iconType: "bag",
  grammarImage: "/u7-everyday-things.jpg",
  grammarText: "Vocabulario de objetos personales y uso natural de posesivos.",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: PERSONAL ITEMS (Enfoque: Asociación Rápida)
    // ----------------------------------------------------------------------
    {
      id: "u7-set1",
      title: "Set 1: Personal Items",
      questions: [
        {
          type: "match",
          q: "Match the object with its action",
          pairs: [
            { left: "Pay money", right: "Wallet" },
            { left: "Open doors", right: "Keys" },
            { left: "Call friends", right: "Phone" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I can't open my house! I lost my ___.", options: ["keys", "wallet", "glasses"], a: "keys" },

        // Fix: sun___ -> sunglasses (más natural)
        { type: "mc", q: "It's sunny. I need my ___.", options: ["sunglasses", "keys", "wallet"], a: "sunglasses" },

        { type: "input", q: "I keep my credit cards and cash in my ___.", a: "wallet" },
        { type: "input", q: "To write a note, I need a piece of paper and a ___.", a: "pen" },

        { type: "order", q: "Ordena la frase", words: ["Where", "is", "my", "phone?"], a: "Where is my phone?" },

        { type: "mc", q: "Context: 'Can I borrow your ___ to write?'", options: ["pen", "wallet", "key"], a: "pen" },
        { type: "input", q: "I read my class notes in my ___.", a: "notebook" },

        // +2 para llegar a 10
        { type: "mc", q: "I want to pay, but I can't find my ___.", options: ["wallet", "keys", "phone"], a: "wallet" },
        { type: "input", q: "I use my ___ to open the door.", a: "keys" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: ELECTRONICS (Enfoque: Uso práctico)
    // ----------------------------------------------------------------------
    {
      id: "u7-set2",
      title: "Set 2: Electronics",
      questions: [
        {
          type: "match",
          q: "Connect the device to the description",
          pairs: [
            { left: "Listen to music", right: "Earphones" },
            { left: "Take photos", right: "Camera" },
            { left: "Read news", right: "Newspaper" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I need to work. I will open my ___.", options: ["laptop", "camera", "earphones"], a: "laptop" },
        { type: "mc", q: "A 'tablet' is similar to a large ___.", options: ["phone", "key", "watch"], a: "phone" },

        { type: "input", q: "I love photography. I have a new Nikon ___.", a: "camera" },
        { type: "input", q: "I use my ___ to listen to Spotify privately.", a: "earphones" },

        { type: "order", q: "Ordena", words: ["My", "laptop", "is", "new."], a: "My laptop is new." },

        { type: "mc", q: "Logical: You can type emails on a ___.", options: ["laptop", "camera", "newspaper"], a: "laptop" },
        { type: "input", q: "For school definitions, I use a ___.", a: "dictionary" },

        // +2 para llegar a 10
        { type: "mc", q: "I want to listen quietly. I need my ___.", options: ["earphones", "camera", "newspaper"], a: "earphones" },
        { type: "input", q: "I read the daily news in the ___.", a: "newspaper" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: CLOTHING & ACCESSORIES (Enfoque: Partes del cuerpo)
    // ----------------------------------------------------------------------
    {
      id: "u7-set3",
      title: "Set 3: Accessories",
      questions: [
        {
          type: "match",
          q: "Where do you wear it?",
          pairs: [
            { left: "On my wrist", right: "Watch" },
            { left: "On my eyes", right: "Sunglasses" },
            { left: "Around my neck", right: "Necklace" }
          ],
          a: "completed"
        },
        { type: "mc", q: "It is raining! Take your ___.", options: ["umbrella", "sunglasses", "wallet"], a: "umbrella" },
        { type: "mc", q: "I need to brush my hair. I need a ___.", options: ["hairbrush", "toothbrush", "pen"], a: "hairbrush" },

        { type: "input", q: "What time is it? I need to check my ___.", a: "watch" },
        { type: "input", q: "For my teeth, I use a ___.", a: "toothbrush" },

        { type: "order", q: "Ordena", words: ["That", "is", "my", "umbrella."], a: "That is my umbrella." },

        { type: "mc", q: "A mirror is for looking at your ___.", options: ["face", "watch", "umbrella"], a: "face" },
        { type: "input", q: "It's very sunny outside. Wear your ___.", a: "sunglasses" },

        // +2 para llegar a 10
        { type: "input", q: "I look in the ___ before I leave home.", a: "mirror" },
        { type: "mc", q: "I wear it around my neck.", options: ["necklace", "watch", "hairbrush"], a: "necklace" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: TRAVEL ITEMS (Enfoque: Aeropuerto/Viaje)
    // ----------------------------------------------------------------------
    {
      id: "u7-set4",
      title: "Set 4: Travel Items",
      questions: [
        {
          type: "match",
          q: "Travel essentials",
          pairs: [
            { left: "To enter a country", right: "Passport" },
            { left: "To find direction", right: "Map" },
            { left: "To pack clothes", right: "Suitcase" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Officer: 'Show me your ID ___ please.'", options: ["card", "map", "coin"], a: "card" },
        { type: "mc", q: "I am thirsty. I need a bottle of ___.", options: ["water", "coins", "passport"], a: "water" },

        { type: "input", q: "I am lost. I need to look at the ___.", a: "map" },
        { type: "input", q: "Don't forget your ___ to fly to London.", a: "passport" },

        { type: "order", q: "Ordena", words: ["Here", "is", "my", "passport."], a: "Here is my passport." },

        // Ajuste: que sea directo (coins = money)
        { type: "mc", q: "Coins are ___.", options: ["money", "food", "paper"], a: "money" },

        { type: "input", q: "Put the letter inside the ___.", a: "envelope" },

        // +2 para llegar a 10
        { type: "input", q: "I pack my clothes in a ___.", a: "suitcase" },
        { type: "mc", q: "At the airport, you show your ___.", options: ["passport", "hairbrush", "magazine"], a: "passport" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: FOOD & BASICS (Enfoque: Cotidiano)
    // ----------------------------------------------------------------------
    {
      id: "u7-set5",
      title: "Set 5: Food & Basics",
      questions: [
        {
          type: "match",
          q: "Match pairs",
          pairs: [
            { left: "Eat", right: "Sandwich" },
            { left: "Drink", right: "Water" },
            { left: "Read", right: "Magazine" }
          ],
          a: "completed"
        },

        { type: "mc", q: "An apple is a healthy ___.", options: ["fruit", "sandwich", "drink"], a: "fruit" },
        { type: "input", q: "I eat soup with a ___.", a: "spoon" },

        { type: "mc", q: "I am hungry. I will make a ___.", options: ["sandwich", "water", "spoon"], a: "sandwich" },
        { type: "input", q: "Red or green fruit. It is an ___.", a: "apple" },

        { type: "order", q: "Ordena", words: ["This", "apple", "is", "red."], a: "This apple is red." },

        { type: "mc", q: "You use a pencil sharpener for your ___.", options: ["pencil", "pen", "spoon"], a: "pencil" },

        // Ajuste: “sports magazines” suena bien, pero el prompt ya no menciona “news”
        { type: "input", q: "I like to read sports ___.", a: "magazines" },

        // +2 para llegar a 10
        { type: "mc", q: "To drink water, you need a ___.", options: ["bottle", "passport", "notebook"], a: "bottle" },
        { type: "input", q: "I am thirsty. I need some ___.", a: "water" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: PLURALS (Enfoque: Gramática Visual/Lógica)
    // ----------------------------------------------------------------------
    {
      id: "u7-set6",
      title: "Set 6: Plurals Practice",
      questions: [
        {
          type: "match",
          q: "Match Singular and Plural",
          pairs: [
            { left: "One Box", right: "Two Boxes" },
            { left: "One Watch", right: "Two Watches" },
            { left: "One Dictionary", right: "Two Dictionaries" }
          ],
          a: "completed"
        },

        { type: "mc", q: "I have one pen, but she has three ___.", options: ["pens", "pen", "penes"], a: "pens" },
        { type: "input", q: "Look at those two ___ (bus).", a: "buses" },

        { type: "mc", q: "Which is correct?", options: ["Three brushes", "Three brushs", "Three brush"], a: "Three brushes" },
        { type: "input", q: "I have two big ___ (box).", a: "boxes" },

        { type: "order", q: "Ordena", words: ["I", "have", "two", "watches."], a: "I have two watches." },

        { type: "mc", q: "Baby -> Babies. City -> ___", options: ["Cities", "Citys", "Cityes"], a: "Cities" },
        { type: "input", q: "This book is mine. Those ___ are yours.", a: "books" },

        // +2 para llegar a 10
        { type: "input", q: "One dictionary, two ___.", a: "dictionaries" },
        { type: "order", q: "Ordena", words: ["These", "are", "three", "brushes."], a: "These are three brushes." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: THIS / THAT / THESE / THOSE (Enfoque: Distancia)
    // ----------------------------------------------------------------------
    {
      id: "u7-set7",
      title: "Set 7: Demonstratives",
      questions: [
        {
          type: "match",
          q: "Match the meaning",
          pairs: [
            { left: "Here (Singular)", right: "This" },
            { left: "There (Singular)", right: "That" },
            { left: "Here (Plural)", right: "These" },
            { left: "There (Plural)", right: "Those" }
          ],
          a: "completed"
        },

        { type: "mc", q: "Look HERE in my hand. ___ is my phone.", options: ["This", "That", "Those"], a: "This" },
        { type: "mc", q: "Look THERE on the table. ___ are my keys.", options: ["Those", "That", "This"], a: "Those" },

        { type: "input", q: "___ (Here) are my friends.", a: "These" },
        { type: "input", q: "___ (There) is my house.", a: "That" },

        { type: "order", q: "Ordena", words: ["This", "is", "my", "bag."], a: "This is my bag." },

        { type: "mc", q: "___ are nice shoes!", options: ["These", "This", "That"], a: "These" },
        { type: "input", q: "Can you pass me ___ book over there?", a: "that" },

        // +2 para llegar a 10
        { type: "mc", q: "Near me: ___ are my books.", options: ["These", "Those", "That"], a: "These" },
        { type: "input", q: "___ (There) are my parents' cars.", a: "Those" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: POSSESSIVES (Enfoque: Pertenencia)
    // ----------------------------------------------------------------------
    {
      id: "u7-set8",
      title: "Set 8: Mine, Yours, His",
      questions: [
        {
          type: "match",
          q: "Connect the pronoun to the possessive",
          pairs: [
            { left: "It belongs to me", right: "Mine" },
            { left: "It belongs to you", right: "Yours" },
            { left: "It belongs to her", right: "Hers" }
          ],
          a: "completed"
        },

        { type: "mc", q: "This is NOT my bag. It is ___.", options: ["yours", "you", "your"], a: "yours" },
        { type: "mc", q: "It's my car. It is ___.", options: ["mine", "my", "me"], a: "mine" },

        { type: "input", q: "That is John's phone. It is ___.", a: "his" },
        { type: "input", q: "We bought this house. It is ___.", a: "ours" },

        { type: "order", q: "Ordena", words: ["This", "wallet", "is", "mine."], a: "This wallet is mine." },

        { type: "mc", q: "Are these keys ___?", options: ["hers", "her", "she"], a: "hers" },
        { type: "input", q: "They own that car. It is ___.", a: "theirs" },

        // +2 para llegar a 10
        { type: "input", q: "This is her umbrella. It is ___.", a: "hers" },
        { type: "mc", q: "We own these books. They are ___.", options: ["ours", "our", "we"], a: "ours" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: MIXED PRACTICE (Integración)
    // ----------------------------------------------------------------------
    {
      id: "u7-set9",
      title: "Set 9: Mixed Practice",
      questions: [
        { type: "mc", q: "Where ___ my sunglasses?", options: ["are", "is", "am"], a: "are" },
        { type: "mc", q: "___ is my new watch.", options: ["This", "These", "Those"], a: "This" },

        { type: "input", q: "I take pictures with my ___.", a: "camera" },

        {
          type: "match",
          q: "Match item to context",
          pairs: [
            { left: "Rain", right: "Umbrella" },
            { left: "Time", right: "Watch" },
            { left: "Sun", right: "Sunglasses" }
          ],
          a: "completed"
        },

        { type: "order", q: "Ordena", words: ["Those", "are", "her", "keys."], a: "Those are her keys." },

        { type: "input", q: "One dictionary. Two ___.", a: "dictionaries" },

        { type: "mc", q: "The passport belongs to him. It is ___.", options: ["his", "him", "he"], a: "his" },
        { type: "input", q: "I need to drink ___.", a: "water" },

        // +2 para llegar a 10
        { type: "mc", q: "Near me: ___ are my earphones.", options: ["These", "This", "That"], a: "These" },
        { type: "order", q: "Ordena", words: ["This", "camera", "is", "hers."], a: "This camera is hers." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTERY (El reto final, pero amigable)
    // ----------------------------------------------------------------------
    {
      id: "u7-set10",
      title: "Set 10: Review Challenge",
      questions: [
        { type: "order", q: "Part 1: Describe the bag", words: ["This", "is", "my", "bag."], a: "This is my bag." },
        { type: "order", q: "Part 2: What is inside?", words: ["It", "has", "my", "keys."], a: "It has my keys." },

        {
          type: "match",
          q: "Ultimate Vocab Check",
          pairs: [
            { left: "Identity", right: "Passport" },
            { left: "Memories", right: "Camera" },
            { left: "Money", right: "Wallet" },
            { left: "Information", right: "Newspaper" }
          ],
          a: "completed"
        },

        { type: "input", q: "Complete: I brush my teeth with a ___.", a: "toothbrush" },
        { type: "mc", q: "Choose the correct plural: Three ___.", options: ["watches", "watchs", "watch"], a: "watches" },

        { type: "input", q: "This isn't your phone. It is ___ (mine).", a: "mine" },
        { type: "mc", q: "___ glasses are expensive.", options: ["These", "This", "That"], a: "These" },

        { type: "input", q: "I am lost. I need a ___.", a: "map" },
        { type: "order", q: "Final Sentence", words: ["These", "books", "are", "ours."], a: "These books are ours." },

        // +1 para llegar a 10
        { type: "mc", q: "Quick check: I pay with my ___.", options: ["wallet", "toothbrush", "map"], a: "wallet" }
      ]
    }
  ]
};
